import { WorkerEmploymentType } from "model/Salary";

export const DEFAULT_PERMANENT_EMPLOYMENT_NOTICE_DAYS = "30";
export const DEFAULT_PERMANENT_EMPLOYMENT_VACATION_DAYS = "25";

export function isPermanentEmployment(
  employmentType: string | undefined,
): boolean {
  return employmentType === WorkerEmploymentType.EMPLOYEE;
}

export function toPermanentEmploymentDefaults(
  companyAddress: string | null | undefined,
): {
  noticeDays: string;
  vacationDays: string;
  workplace: string;
} {
  return {
    noticeDays: DEFAULT_PERMANENT_EMPLOYMENT_NOTICE_DAYS,
    vacationDays: DEFAULT_PERMANENT_EMPLOYMENT_VACATION_DAYS,
    workplace: companyAddress?.trim() ?? "",
  };
}
